import type {
  EventHandlerCb,
  ExtendedConstraints,
  CapabilityConfig,
} from '../../types';
import { hasOnlyKeysFromSet } from '../../utils';

export const id = 'app-token';

export enum Events {
  GetStatus = 'app-token:get-status',
  /**
   * @deprecated will be removed soon, please use app-token:get-status event and its successful payload.
   */
  Update = 'app-token:update',
}

export enum Actions {
  Get = 'app-token:get',
}

export type Config = CapabilityConfig & {
  type: typeof id;
};
/**
 * @deprecated UpdatePayload will be removed with update event.
 */
export type UpdatePayload = string;
export type GetStatusPayload = {
  isSuccess: boolean;
  errorMessage?: string;
  data?: string;
};

/**
 * @deprecated GetPayload will be removed from get event.
 */
export type GetPayload = {
  appName: string;
};

export type Constraints = ExtendedConstraints<{
  events: Events;
  actions: Actions;
  config: Config;
  eventPayloadTuple:
    | [Events.Update, UpdatePayload]
    | [Events.GetStatus, GetStatusPayload];
  eventHandlerTuple:
    | [Events.Update, EventHandlerCb<UpdatePayload>]
    | [Events.GetStatus, EventHandlerCb<GetStatusPayload>];
  actionPayloadTuple: [Actions.Get] | [Actions.Get, GetPayload];
}>;

const VALID_CONFIG_KEYS = ['type'] as const;
export function isValidConfig(config: CapabilityConfig): config is Config {
  if (!hasOnlyKeysFromSet(config, VALID_CONFIG_KEYS)) {
    return false;
  }

  return config.type === id;
}
